import InviteUser from "../components/UserManagement/Invite/InviteUser";

const InviteUserPage = (props) => {
    return <InviteUser />;
}

export default InviteUserPage;